import Tooltip from "rc-tooltip";
import React, { useEffect, useMemo } from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import Dashboard from "../../../components/Dashboard";
import CloseIcon from "../../../components/icons/CloseIcon";
import InfoIcon from "../../../components/icons/InfoIcon";
import { useFilteredList } from "../../../context/filteredList";
import { useHotspots } from "../../../context/hotspots";
import { Entity } from "../../../utils/constants";
import useMapCenter from "../../../utils/useMapCenter";

interface Props extends RouteComponentProps<{}> {}

const MapDashboard: React.FC<Props> = () => {
  const { fetchRewardSummariesByHex, fetchWitnessesCountsByHex } =
    useHotspots();
  const { filteredList } = useFilteredList();
  const centerInH3HexRes4 = useMapCenter((state) => state.centerInH3HexRes4);

  const filteredHotspots = useMemo(
    () => filteredList[Entity.hotspot],
    [filteredList]
  );

  useEffect(() => {
    if (centerInH3HexRes4) {
      fetchRewardSummariesByHex(centerInH3HexRes4);
      fetchWitnessesCountsByHex(centerInH3HexRes4); // Needed to calculate the witness reward units
    }
  }, [centerInH3HexRes4, fetchRewardSummariesByHex, fetchWitnessesCountsByHex]);

  return (
    <article className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="-mt-5">
        <div className="flex justify-end">
          <nav className="flex" aria-label="Close">
            <span className="relative z-0 shadow-sm rounded-md flex justify-between items-center">
              <Link
                to="/hotspots"
                className="-ml-px relative inline-flex items-center px-4 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-hotspotty-500 focus:border-hotspotty-500 dark:bg-gray-900 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:bg-gray-800 dark:border-gray-700"
              >
                <CloseIcon className="h-5 w-5" />
              </Link>
            </span>
          </nav>
        </div>
        <div className="sm:flex-1 sm:min-w-0 sm:flex sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
          <div className="min-w-0 flex-1">
            <h1 className="text-md sm:text-2xl font-bold text-gray-900 dark:text-white truncate inline-flex items-center">
              <div className="flex-1 flex items-center">
                <span className="mr-2">Region dashboard</span>
                <Tooltip
                  placement="right"
                  overlay="Based on the (filtered) list of hotspots fetched for the purple zone around the center of the map."
                >
                  <InfoIcon className="inline-flex h-5 w-5" />
                </Tooltip>
              </div>
            </h1>
          </div>
        </div>
      </div>

      <Dashboard hotspots={filteredHotspots} />
    </article>
  );
};

export default MapDashboard;
